import ConsumerRefService from "@api/consumer/consumerRefService";
import {FC, useCallback} from "react";
import {useNavigate} from "react-router";
import {toastr} from "@/utils/toastHelper";
import withPage from "@components/hoc/withPage";
import {ConditionType, GoalFormValues} from "./forms/goalBaseInfoBlock";
import GoalForm from "./goalForm";

const AddGoalForm: FC = () => {

    const initialValues: GoalFormValues = {
        name: '',
        description: '',
        isActive: false,
        order: 0,
        conditionType: ConditionType.All,
        hidden: false,
        groupIds: []
    }

    const navigate = useNavigate();



    const onSubmit = useCallback(async (values: GoalFormValues) => {
        const api = new ConsumerRefService();
        const result = await api.putGoal({
            name: values.name,
            description: values.description,
            order: values.order,
            groupIds: values.groupIds
        });

        if(result.success) {
            toastr.success("Создание достижения", "Достижение успешно создано");
            navigate(`/consumer/goals/${result.data.id}/`, { replace: true });
        }
        else {
            if(result.errorCode === 'GoalNotFound') {
                toastr.error('Создание достижения', 'Достижение не найдено');
            }
            else {
                toastr.error('Создание достижения', 'Неизвестная ошибка');
            }
        }
    }, [navigate]);

    return (
        <GoalForm
            initialValues={initialValues}
            onSubmit={onSubmit}
            editForm={false}
            cancelUrl="/consumer/goals/"
        />
    )
}

export default withPage(AddGoalForm);
